import { VENDOR_AGGREGATION_GROUP } from "@dransay/api/models";
import { useCallback, useEffect, useState } from "react";

export function useShowAllMapMarkers(
	selectedValue: string | undefined,
	enableTopPharmacyCartPromotion: boolean,
) {
	const [showAllMapMarkers, setShowAllMapMarkers] = useState(
		() => selectedValue === VENDOR_AGGREGATION_GROUP.ALL,
	);
	const handleMapShowAllMarkersChange = useCallback((showAll: boolean) => {
		setShowAllMapMarkers(showAll);
	}, []);
	useEffect(() => {
		if (!enableTopPharmacyCartPromotion) {
			return;
		}
		if (selectedValue === VENDOR_AGGREGATION_GROUP.ALL) {
			setShowAllMapMarkers(true);
			return;
		}
		if (selectedValue === VENDOR_AGGREGATION_GROUP.TOP) {
			setShowAllMapMarkers(false);
		}
	}, [selectedValue, enableTopPharmacyCartPromotion]);
	return { showAllMapMarkers, handleMapShowAllMarkersChange };
}
